import type { ListerProposal } from "../../../lib/api";

export default function CollectionsEditor({ collections, accepted, onToggle }: { collections: ListerProposal["collections"]; accepted: string[]; onToggle: (title: string) => void }) {
  if (collections.length === 0) return <div className="text-zinc-500 text-xs">No collections match these tags.</div>;
  return (
    <ul className="space-y-1 font-mono text-sm">
      {collections.map((c) => (
        <li key={c.title} className="flex items-center gap-2">
          {c.is_new ? (
            <label className="flex items-center gap-2 cursor-pointer py-2"><input type="checkbox" className="h-5 w-5" checked={accepted.includes(c.title)} onChange={() => onToggle(c.title)} /><span className="text-amber-200">{c.title}</span><span className="text-[10px] text-zinc-500">new · rule tag "{c.rule_tag}"</span></label>
          ) : (
            <><span className="text-green-300">✓</span><span className="text-zinc-200">{c.title}</span><span className="text-[10px] text-zinc-500">auto via tag "{c.rule_tag}"</span></>
          )}
        </li>
      ))}
    </ul>
  );
}
